import React, { Component } from 'react';

class ConditionedComponent extends Component {
    render() {
        if (!this.props.condition) {
            return (<div></div>);
        }

        return this.props.children;
    }
}

export default ConditionedComponent;
